module.exports = __webpack_public_path__ + "img/icon_about_07.ee0ea1e1.png";